//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {}
  },
  props: {
    item: {
      type: Object,
    },
    status: {
      type: Number,
    },
  },
  computed: {},
  methods: {
    onListClicked() {
      console.log(this.item)
      if (this.item.startDate) {
        const startDate = this.item.startDate.replace(/-/g, '/')
        console.log(startDate)
        const dateParse = new Date(startDate).getTime() - new Date().getTime()
        if (dateParse > 0) {
          new this.$Dialog({
            title: '温馨提示',
            text: `问卷未开始，开始时间：${startDate}`,
            theme: 'ios',
            isConfirm: false,
          })
          return
        }
      }
      this.$router.push({
        name: 'detail',
        query: {
          questionnaireId: this.item.questionnaireId,
          tenantId: this.item.tenantId,
          limitSetting: this.item.limitSetting,
          currentListStatus: this.status, // 当前列表状态
        },
      })
    },
    getTipText({ limitRate, limitNumber, startDate }) {
      let tip = ''
      let isStarttime = this.getIsStartTime(startDate)
      switch (limitRate) {
        // 设置开始时间，但未到时间  提示后者  否则前者
        case 'day':
          tip = isStarttime ? '今天还能' : '每日可'
          break
        case 'week':
          tip = isStarttime ? '本周还能' : '每周可'
          break
        case 'month':
          tip = isStarttime ? '本月还能' : '每月可'
          break
      }
      // console.log("limitRate: ", limitRate, limitNumber, startDate, isStarttime)
      return `${tip}填报${limitNumber}次`
    },
    getIsStartTime(startDate) {
      startDate = startDate.split('-').join('/')
      let startTime = new Date(startDate).getTime()
      let nowTime = new Date().getTime()
      // console.log(startDate, startTime, nowTime)
      return nowTime >= startTime ? true : false
    },
  },
}
